module.exports = __webpack_public_path__ + "img/ic／3.c7c5490f.png";